import { RouteLocationNormalized, Router } from "vue-router"
import { useCurrentAccountStore } from "@/stores/currentAccount"
import { queryClient } from "@/api/utils/useQuery"

export function registerCustomerMiddleware(router: Router) {
  router.beforeEach(async (to: RouteLocationNormalized) => {
    const accountNumber = Array.isArray(to.params.accountNumber)
      ? to.params.accountNumber[0]
      : to.params.accountNumber

    document.title = "Nova"

    if (accountNumber && to.path.startsWith("/customer/")) {
      if (useCurrentAccountStore().accountNumber !== accountNumber) {
        queryClient.clear()
      }

      useCurrentAccountStore().accountNumber = accountNumber
      document.title = `Account ${to.params.accountNumber}`
    }

    return true
  })
}
